import { Pipe, PipeTransform } from '@angular/core';
import { GlxyMarkdownPipe } from '@vendasta/galaxy/pipes';
import { ConversationChannel } from '@vendasta/conversation';
import { MarkedRenderer } from 'ngx-markdown';
import { ReplaceNewLinePipe, TruncateMessagePipePipe } from './message.pipes';
import { ConversationMessage } from '../../core/src/lib/interface/conversation.interface';
import { marked } from 'marked';

@Pipe({ name: 'formatMessage', standalone: false })
export class FormatMessagePipe implements PipeTransform {
  private readonly markdown = new GlxyMarkdownPipe();
  private readonly truncate = new TruncateMessagePipePipe();
  private readonly replaceNewline = new ReplaceNewLinePipe();

  transform(value: string, item: ConversationMessage, internalDomains: string[]): string {
    if (!value) return '';

    const shouldUseCustomLinkRenderer = item.channel === ConversationChannel.CONVERSATION_CHANNEL_AI_ASSISTANT;

    let result = value;

    if (item.channel === ConversationChannel.CONVERSATION_CHANNEL_EMAIL) {
      result = this.truncate.transform(result, item);
    }

    result = this.replaceNewline.transform(result);

    let html: string;
    if (shouldUseCustomLinkRenderer) {
      html = marked.parse(result, { renderer: this.createCustomLinkRenderer(internalDomains) }) as string;
    } else {
      html = this.markdown.transform(result);
    }

    return html;
  }

  private createCustomLinkRenderer(internalDomains: string[]): MarkedRenderer {
    const renderer = new MarkedRenderer();

    renderer.link = (href: string, title: string, text: string) => {
      const isInternal = Array.isArray(internalDomains) && internalDomains.some((domain) => href?.includes(domain));

      const targetAttr = isInternal ? '' : ' target="_blank" rel="noopener noreferrer"';
      const titleAttr = title ? ` title="${title}"` : '';
      return `<a href="${href}"${titleAttr}${targetAttr}>${text}</a>`;
    };

    return renderer;
  }
}
